export default {
      id: "i-login-client-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-login-client",
      toString: function () {
        return this.url;
      }
    }